import React, { useState } from "react";
import manualChange from "../../../controllers/booking/postTicketing/change/manualChange";
import { enqueueSnackbar } from "notistack";
import Button1 from "../../form/Button1";
import { el } from "date-fns/locale";
import {
  changeOrderConfirmTravellers,
  changeOrderContructFlightDetails,
  changeOrderRouteChange,
} from "../../../controllers/ticketManagement/changeDateControllers";

export default function ManualUpdate({ data, callback, close }) {
  const [loadings, setLoadings] = useState({ submit: false });
  // const flights = data?.flightBooking?.at(0)?.flights?.filter(flight => data?.directionsToChange?.includes(flight?.segmentRef)) || [];
  const selectedOffer =
    typeof data?.selectedOffer === "string"
      ? JSON.parse(data?.selectedOffer)
      : data?.selectedOffer || null;

  // console.log({ selectedOffer, data });

  async function handleManual() {
    const payload = {
      changeOrderId: data?._id,
      // "travelers": [
      //     // {
      //     //     "id": ""
      //     // }
      // ],
      //   "pnr": newPNR || undefined
    };

    if (data?.newSegment?.length || selectedOffer) {
      if (selectedOffer) {
        const routeChange = changeOrderRouteChange(
          data?.flightBooking,
          data?.selectedOffer,
        );
        if (!routeChange) {
          const { flights, destinations } =
            changeOrderContructFlightDetails(data);
          payload.flights = flights;
          payload.destinations = destinations;
        } else {
          const segments = selectedOffer?.directions?.flatMap(
            (direction, index) =>
              direction.map((segment) => ({
                ...segment,
                segment: `${index + 1}`,
              })),
          );
          payload.flights = segments.map((segment) => ({
            ...segment,
            aircraftCode: segment.aircraftCode,
            flightNumber: segment.flightNumber,
            departureTime: segment.departure.time,
            departureDate: segment.departure.date,
            departureLocation: segment.departure.location,
            departureAirport: segment.departure.airport,
            departureLocationName: segment.departure.city,
            arrivalTime: segment.arrival.time,
            arrivalDate: segment.arrival.date,
            arrivalLocation: segment.arrival.location,
            arrivalAirport: segment.arrival.airport,
            arrivalLocationName: segment.arrival.city,
            cabinClass: segment.cabinClass,
            bookingClass: segment.bookingClass,
            segmentRef: segment.segmentRef,
            airlineImage: segment.airline.image.url,
            airlineName: segment.airline.image.description,
            airline: segment.airline.marketing,
          }));
          payload.destinations = (selectedOffer?.destinations || []).map(
            (destination) => ({
              from: destination?.from || "",
              to: destination?.to || "",
              departureDate: destination?.departure?.date || "",
            }),
          );
        }
        // if (data?.passengerInfo?.length) {
        //   payload.travelers = data?.passengerInfo || [];
        // }
      } else {
        payload.flights = data?.flightBooking?.at(0)?.flights?.map((flight) => {
          let segment = data?.newSegment?.find(
            (seg) => seg?.segmentRef === flight?.segmentRef,
          );
          if (!segment) return flight;

          return {
            ...flight,
            _id: segment.id || flight?._id,
            stops: flight?.stops,
            aircraftCode: segment.aircraftCode || flight?.aircraftCode,
            flightNumber: segment.flightNumber || flight?.flightNumber,
            departureTime: segment.departure.time || flight?.departureTime,
            departureDate: segment.departure.date || flight?.departureDate,
            departureLocation:
              segment.departure.location || flight?.departureLocation,
            departureAirport:
              segment.departure.airport || flight?.departureAirport,
            departureLocationName:
              segment.departure.city || flight?.departureLocationName,
            arrivalTime: segment.arrival.time || flight?.arrivalTime,
            arrivalDate: segment.arrival.date || flight?.arrivalDate,
            arrivalLocation:
              segment.arrival.location || flight?.arrivalLocation,
            arrivalAirport: segment.arrival.airport || flight?.arrivalAirport,
            arrivalLocationName:
              segment.arrival.city || flight?.arrivalLocationName,
            cabinClass: segment.cabinClass || flight?.cabinClass,
            bookingClass: segment.bookingClass || flight?.bookingClass,
            segmentRef: segment.segmentRef || flight?.segmentRef,
            airlineImage: segment.airline.image.url || flight?.airlineImage,
            airlineName:
              segment.airline.image.description || flight?.airlineName,
            airline: segment.airline.marketing || flight?.airline,
          };
        });

        payload.destinations = data?.flightBooking
          ?.at(0)
          ?.destinations // ?.filter((_,i) =>
          //   flights?.find(flight => Number(flight?.segment)-1 === i)
          // )
          ?.map((obj, i) => {
            let newDate = data?.newDirections?.find(
              (dir) => Number(dir?.segment) - 1 === i,
            )?.departure;
            return {
              ...obj,
              departureDate: newDate ? newDate : obj?.departureDate,
              // moment(flights?.find(flight => Number(flight?.segment)-1 === i)?.departureDate)?.format('YYYY-MM-DD')
            };
          });
      }
    } else if (data?.changeRequest === "PassengerInfo") {
      payload.travelers = data?.passengerInfo;
    }
    if (data?.passengerInfo?.length) {
      // payload.travelers = data?.passengerInfo?.map(({ _id, ...obj }) => obj);
      payload.travelers = changeOrderConfirmTravellers(data);
    }

    setLoadings({ ...loadings, submit: true });
    const res = await manualChange(payload);
    setLoadings({ ...loadings, submit: false });
    if (res.return) {
      enqueueSnackbar("Update Succesfull.", { variant: "success" });
      callback && callback();
    } else enqueueSnackbar(res.msg, { variant: "error" });
  }

  return (
    <div className="flex flex-col gap-6">
      {/* {data?.changeRequest === 'PassengerInfo' ? 
        <ManualPassengerForm {...{data:travelers,setData:setTravelers}} passengers={data?.passengerInfo} />
      :
        <ManualFlightDetailForm {...{data:newSegment,setData:setNewSegment}} dataObj={data} />
      } */}
      <div>
        <h5>Are you sure you want to confirm this change?</h5>
        <p>Please review the change request and confirm they are accurate.</p>
      </div>
      <div className="flex gap-4">
        <div>
          {close ? (
            <Button1 onClickc={() => close()} variant="outlined">
              Cancel
            </Button1>
          ) : null}
        </div>
        <Button1 loading={loadings.submit} onClick={handleManual}>
          Confirm
        </Button1>
      </div>
    </div>
  );
}
